import { useEffect } from "react";

import { isDev } from "@brexhq/shared/utils/env/isDevEnv";

import { ExperimentViewedEvent } from "../../telemetry/analyticsEvents";
import { StatsigExperimentStatus } from "../../utils/experimentation/createMiddlewareConfig";
import useAnalytics from "../useAnalytics";

export type ExperimentAnalyticsData = {
  experimentId: string;
  variation: string;
  experimentType: string;
  experimentStatus: StatsigExperimentStatus;
} | null;

/**
 * if the experimentAnalyticsData object is present, track the experiment view event
 * @param experimentAnalyticsData - object containing experimentId and variation or null
 */
export const useTrackStatsigIfExperiment = (
  experimentAnalyticsData: ExperimentAnalyticsData,
) => {
  const { trackEvent, identify } = useAnalytics();
  // Send event in dev so we can verify that the event is being sent to segment. This will take precedence over the experiment status
  const shouldTrack =
    experimentAnalyticsData?.experimentStatus === "active" || isDev;

  useEffect(() => {
    if (experimentAnalyticsData && shouldTrack) {
      const experimentEvent = new ExperimentViewedEvent({
        variantId: experimentAnalyticsData.variation,
        experimentId: experimentAnalyticsData.experimentId,
        experimentType: experimentAnalyticsData.experimentType,
        experimentTool: "Statsig",
      });
      trackEvent(experimentEvent);
      identify({
        properties: {
          [experimentAnalyticsData.experimentId]:
            experimentAnalyticsData.variation,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [experimentAnalyticsData, shouldTrack]);
};
